module.exports = __webpack_public_path__ + "media/investor_dashboard/bulb-ab1fff06.svg";